define([
  "jquery",
  "marionette",
  "./template/topicCopyResponseLocaleAndTouchpointTemplate.html",
], function ($, Marionette, TopicCopyResponseModalTemplate) {
  "use strict";

  const TopicCopyResponseModalView = {};

  TopicCopyResponseModalView.localeAndTouchpointView = Marionette.Layout.extend({
    template: TopicCopyResponseModalTemplate,
    regions: {
      copyResponseList: "#copyResponseList",
    },
    triggers: {
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#copyResponseError").hide();
    },
    showError: function () {
      const message = $.t("topic.copyResponse.error");
      this.$el.find("#copyResponseError").text(message).show();
    },
    hideWarning: function () {
      this.$el.find("#copyResponseError").hide();
    },
  });

  return TopicCopyResponseModalView;
});
